import { ChevronRightIcon } from '@heroicons/react/24/solid'

import { useProjectList } from '@/api/models/main'
import { AppButton } from '@/components/shared/button'

type Props = {
  onClick: () => void
  selectedProjectName: string
}

export const SidebarProjectSelector = ({
  onClick,
  selectedProjectName
}: Props) => {
  const { data: projectList = [] } = useProjectList()

  const isProjectOne = projectList.length === 1

  return (
    <AppButton
      filledWith="icon-append"
      size="small"
      className="mx-16 !h-52 justify-between !border-0 !bg-grey-90"
      onClick={() => !isProjectOne && onClick()}
    >
      <span
        className="font-semibold text-white text-20"
        data-testid="selected-project-name-mobile"
      >
        {selectedProjectName}
      </span>
      {!isProjectOne && <ChevronRightIcon className="h-20 w-20 text-white" />}
    </AppButton>
  )
}
